type TimeSeriesDataPoint = [number, (number | undefined)?, (number | undefined)?];

const WEATHER_DECIMAL_PLACES = 1;

/**
 * Rounds a weather value to the display precision (1 decimal place).
 */
export function roundWeatherValue(value: number | undefined) {
  if (value == null || !Number.isFinite(value)) return;
  return Number(value.toFixed(WEATHER_DECIMAL_PLACES));
}

/**
 * Find the variable with the lowest sample rate from the given list.
 */
export function findLowestSampleRateVariable<T extends { sampleRate: number }>(variables: T[]) {
  if (!variables.length) return undefined;
  return variables.reduce((lowest, curr) => {
    if (curr.sampleRate < lowest.sampleRate) return curr;
    return lowest;
  });
}

/**
 * Find the value at the data point whose timestamp is closest to targetMillis.
 */
export function findClosestValueInTimeSeries(data: TimeSeriesDataPoint[] | undefined, targetMillis: number) {
  if (!data?.length) return undefined;
  return data.reduce((closest, current) => {
    const [currentTime] = current;
    const [closestTime] = closest;
    return Math.abs(currentTime - targetMillis) < Math.abs(closestTime - targetMillis) ? current : closest;
  })[1];
}
